import { handleConsentOverlay } from "@sazka/utils/gdpr/consent-overlay";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";

async function initConsentOverlay() {
    await showConsentOverlay();

    eventBus.on(GlobalEvents.ConsentsChanged, async () => {
        await showConsentOverlay();
    });
}

async function showConsentOverlay() {
    const element = document.querySelector(".ds-rich-text-hero__video") as HTMLElement;
    const heroOverlay = document.querySelector(".hc-hero--outside-wrap");

    if (!element) return;

    const embedUrl = `//www.youtube-nocookie.com/embed/${element.dataset.videoCode}`;

    const overlayAdded = await handleConsentOverlay(element, embedUrl);

    if (overlayAdded && heroOverlay) {
        const overlayBtn = document.querySelector(".gdpr-overlay__button");
        heroOverlay.setAttribute("style", "--overlay-height: 75%");

        overlayBtn.addEventListener("click", function () {
            heroOverlay.removeAttribute("style");
        });
    }

    if (!overlayAdded) {
        element.insertAdjacentHTML("afterbegin", `<iframe src="${embedUrl}" frameborder="0" allowfullscreen></iframe>`);
    }
}

document.ready(initConsentOverlay);
